var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 55,
    viewBox: "0 0 65 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3359 40.2361L39.9328 4.18867C38.1531 1.78086 35.4312 0.419922 32.5 0.419922C29.4641 0.419922 26.7422 1.78086 25.0672 4.18867L2.66406 40.2361C0.570305 43.0626 0.256243 46.7267 1.82656 49.8673C3.39687 53.0079 6.53749 54.997 10.0969 54.997H54.9031C58.4625 54.997 61.6031 53.0079 63.1734 49.8673C64.7437 46.8314 64.4297 43.0626 62.3359 40.2361ZM58.9859 47.7736C58.1484 49.3439 56.6828 50.2861 54.9031 50.2861H10.0969C8.31718 50.2861 6.85155 49.3439 6.01405 47.7736C5.28124 46.2033 5.38593 44.4236 6.4328 43.0626L28.8359 7.01523C29.6734 5.86367 31.0344 5.13086 32.5 5.13086C33.9656 5.13086 35.3266 5.75898 36.1641 7.01523L58.5672 43.0626C59.6141 44.4236 59.7187 46.2033 58.9859 47.7736Z",
    fill: "#B42318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 19.8916C31.2436 19.8916 30.092 20.9385 30.092 22.2994V33.7104C30.092 34.9666 31.1389 36.1182 32.4999 36.1182C33.8608 36.1182 34.9077 35.0713 34.9077 33.7104V22.1947C34.9077 20.9385 33.7561 19.8916 32.4999 19.8916Z",
    fill: "#B42318"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 38.875C31.2436 38.875 30.092 39.9219 30.092 41.2828V41.8062C30.092 43.0625 31.1389 44.2141 32.4999 44.2141C33.8608 44.2141 34.9077 43.1672 34.9077 41.8062V41.1781C34.9077 39.9219 33.7561 38.875 32.4999 38.875Z",
    fill: "#B42318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg28);
export default __webpack_public_path__ + "static/media/svg28.a10e27568ae1baccf467e481e116a550.svg";
export { ForwardRef as ReactComponent };